export const work_experience = [
    { date: "2023 - 2024", role: "Software Engineering - Backend specialization", organisation: "African Leadership Experience- ALX" },
    { date: "2022 - Till Date", role: "IT Support Specialist", organisation: "Crest-Agro Products Ltd." },
    { date: "2019 - 2022", role: "ICT Educator", organisation: "Success Schools Sokoto" },
    { date: "2008 - 2012", role: "IT Technical Support Internship", organisation: "Topstock Computers" },
];

export const education = [
    { date: "2023 - 2024", schoolName: "African Leading X (ALX Africa)", qualification: "Software Engineering (Fullstack)" },
    { date: "2018 - 2019", schoolName: "Umaru Ali Shinkafi Polytechnic", qualification: "HND (Computer Science)" },
    { date: "2013 - 2015", schoolName: "Waziri Umaru Federal Polytechnic", qualification: "ND (Computer Science)" },
];
  
export const certificationsData = [
    { title: "Foundation Degree in Software Engineering (2024)", organisation: "African Leadership Experience (ALX)", url: "https://savanna.alxafrica.com/certificates/phe5B2JYsx", certType: 1 },
    { title: "Coding to 6 Figures Program (2023)", organisation: "Blakio LLC", url: "www.blakio.com", certType: 1 },
    { title: "Web Development (2022)", organisation: "Udemy", url: "www.udemy.com", certType: 1 },
    { title: "Higher National Diploma in Computer Science (2020)", organisation: "Umaru Ali Shinkafi Polytechnic", url: null, certType: 1 },
    { title: "National Diploma in Conputer Science (2016)", organisation: "Waziri Umaru Federal Polytechnic", url: null, certType: 1 }
];

export const qaData = [
    {
      question: "Are you legally authorized to work in the US?",
      answer: "No, I am based in Nigeria, but I am open to remote opportunities and international collaboration."
    },
    {
      question: "How many years of experience do you have?",
      answer: "Over 10 years of experience in IT Technical Support, and software development."
    },
    {
      question: "Do you prefer to work alone or in a team?",
      answer: "I prefer working in a team for collaboration and knowledge sharing, but I’m also very comfortable working independently when needed."
    },
    {
      question: "Do you have current CPR(Cardiopulmonary Resuscitation) Certification?",
      answer: "No - CPR certification is not required for my field of expertise as a software engineer."
    },
    {
      question: "Are you open to relocation?",
      answer: "I am open to remote work and short-term relocation if required, depending on the opportunity and visa sponsorship."
    },
    {
      question: "What programming languages are you most proficient in?",
      answer: "I am proficient in PHP (Laravel), JavaScript (React), TypeScript, Python (Flask), and C."
    },
    {
      question: "What development tools or frameworks do you commonly use?",
      answer: "I regularly use Laravel, React, Express.js, Bootstrap, Git, Docker, and MySQL/PostgreSQL."
    },
    {
      question: "What is your experience with version control systems?",
      answer: "I have extensive experience with Git and GitHub for version control, collaboration, and CI/CD workflows."
    },
    {
      question: "Do you have experience working remotely?",
      answer: "Yes, I have successfully worked remotely with distributed teams, using tools like Slack, Zoom, Trello, and GitHub."
    },
    {
        question: "What is your preferred development environment?",
        answer: "I primarily use VS Code for its robust extensions and debugging support, and Vim for quick edits and terminal-based work. My workflow often includes a Linux environment and tools like Docker for containerized development."
    }
    ,
    {
      question: "How do you handle tight deadlines or high-pressure situations?",
      answer: "I prioritize tasks, communicate clearly with team members, and stay focused on delivering incremental progress without compromising code quality."
    },
    // {
    //   question: "Do you have experience with testing or QA processes?",
    //   answer: "Yes, I use PHPUnit, Jest, and Cypress for automated testing, and I follow TDD when applicable."
    // },
    {
      question: "Are you comfortable working across time zones?",
      answer: "Yes, I have experience coordinating with teams across multiple time zones and maintaining flexible working hours."
    },
    {
      question: "Do you have any certifications or formal training?",
      answer: "Yes, I hold a Bachelor's degree in Computer Science and have completed several online certifications in full-stack development and cloud computing."
    },
    {
      question: "What are your career goals?",
      answer: "My goal is to continue growing as a software engineer while contributing to impactful projects and eventually mentoring junior developers or leading engineering teams."
    }
];
  

export const skillData = [
    { skill: "HTML", rating: 5 },
    { skill: "JavaScript", rating: 5 },
    { skill: "CSS", rating: 5 },
    { skill: "PHP", rating: 4 },
    { skill: "Python", rating: 3 },
    { skill: "C Programming", rating: 3 },
    { skill: "React", rating: 4 },
    { skill: "Laravel", rating: 3 },
    { skill: "Flask", rating: 3 },
    { skill: "Django", rating: 3 },
    { skill: "Bootstrap", rating: 4 },
    { skill: "IT Support Specialist", rating: 5 },
];